import { request } from 'utils/requests'

// Central de notificações (sino)
export const listarCentral = async (params = {}) => (await request.get('/notifications/central', { params })).data
export const contarCentral = async () => (await request.get('/notifications/central/contagem')).data
export const marcarLeituraCentral = async (alvo = {}, lida = true) => (await request.post('/notifications/central/leitura', { ...alvo, lida })).data
